import { createContext } from 'react'

interface NetworkWizardContextType {
  //TODO: job must have type DomainOverload from SWC but there is bug that is why 'any' for now
  job?: any
  homeId?: string
  domainId?: string
  isLoading: boolean
  handleCloseWizard: () => void
  refetchJobData: () => void
}

const initNetworkWizardContext: NetworkWizardContextType = {
  job: undefined,
  homeId: undefined,
  domainId: undefined,
  isLoading: false,
  handleCloseWizard: () => {},
  refetchJobData: () => {},
}

export const NetworkWizardContext = createContext<NetworkWizardContextType>(
  initNetworkWizardContext
)
